import { render, staticRenderFns } from "./addressBookList.vue?vue&type=template&id=4cd11ca8&scoped=true&"
import script from "./addressBookList.vue?vue&type=script&lang=js&"
export * from "./addressBookList.vue?vue&type=script&lang=js&"
import style0 from "./addressBookList.vue?vue&type=style&index=0&id=4cd11ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd11ca8",
  null
  
)

export default component.exports